import * as React from "react";
import {
  ImageField,
  TextInput,
  ImageInput,
  BooleanInput,
  Edit,
  FormDataConsumer,
  NumberInput,
  useRecordContext,
  Title,
  // Labeled,
} from "react-admin";
import { SimpleForm } from "../common/SimpleForm";
import { IMAGE_MAX_SIZE } from "../constants/FileConstants";
import { validateOrder, validateRequired } from "../utils/Validations";

const PlaceTargetTitle = () => {
  const record = useRecordContext();
  return <Title title={`Target de Lugar "${record?.name}"`} />;
};

const PlaceTargetEdit = () => (
  <Edit title={<PlaceTargetTitle />} mutationMode="pessimistic" redirect="list">
    <SimpleForm>
      <TextInput source="name" label="Nombre" validate={validateRequired} />
      <ImageInput
        source="image"
        label="Imagen"
        accept={{
          "image/*": [],
        }}
        validate={validateRequired}
        maxSize={IMAGE_MAX_SIZE}
      >
        <ImageField source="src" title="title" />
      </ImageInput>
      <FormDataConsumer>
        {({ formData, ...rest }) => {
          if (!formData?.image?.rawFile) {
            return <ImageField source="image" {...rest} />;
          }
        }}
      </FormDataConsumer>
      <NumberInput
        source="order"
        label="Orden"
        min={1}
        validate={validateOrder}
        onWheel={(e) => e.target.blur()}
      />
      <BooleanInput source="visible" label="Visible" />
      <BooleanInput source="active" label="Activo" />
    </SimpleForm>
  </Edit>
);

export default PlaceTargetEdit;
